import React from 'react';
import './Careers.css';
import { FaUserMd, FaStethoscope, FaHandHoldingHeart, FaEnvelope } from 'react-icons/fa';

const Careers = () => {
    const jobs = [
        {
            icon: <FaUserMd />,
            title: "Senior Resident Doctor",
            department: "Cardiology",
            type: "Full Time",
            location: "Main Hospital",
            description: "Looking for an experienced Senior Resident with 3+ years of experience in interventional cardiology."
        },
        {
            icon: <FaStethoscope />,
            title: "Nursing Staff",
            department: "ICU & Emergency",
            type: "Full Time / Rotational Shifts",
            location: "Main Hospital",
            description: "Certified compassionate nurses required for critical care units. GNM/B.Sc Nursing qualified."
        },
        {
            icon: <FaHandHoldingHeart />,
            title: "Patient Care Coordinator",
            department: "Administration",
            type: "Full Time",
            location: "Front Desk",
            description: "Friendly professional to handle patient queries, appointments and ensure smooth experience."
        },
        {
            icon: <FaUserMd />,
            title: "General Surgeon",
            department: "Surgery",
            type: "Full Time",
            location: "Main Hospital",
            description: "Board certified general surgeon with expertise in laparoscopic procedures."
        }
    ];

    return (
        <div className="careers-page">
            <div className="careers-hero">
                <div className="container">
                    <h1>Join Our Team</h1>
                    <p>Build a rewarding career with JDS Hospitals. We are always looking for passionate individuals to join our mission of care.</p>
                </div>
            </div>

            <section className="jobs-section">
                <div className="container">
                    <h2 className="section-title">Current Openings</h2>
                    <div className="jobs-grid">
                        {jobs.map((job, index) => (
                            <div key={index} className="job-card">
                                <div className="job-header">
                                    <div className="job-icon">{job.icon}</div>
                                    <span className="job-type">{job.type}</span>
                                </div>
                                <h3>{job.title}</h3>
                                <div className="job-meta">
                                    <span className="job-dept">{job.department}</span>
                                    <span className="job-loc">• {job.location}</span>
                                </div>
                                <p>{job.description}</p>
                                <button className="apply-btn">Apply Now</button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="apply-section">
                <div className="container">
                    <div className="apply-box">
                        <div className="apply-content">
                            <h2>Don't see a matching role?</h2>
                            <p>We are always open to meeting talented professionals. Send your CV to our HR team and we will get back to you.</p>
                        </div>
                        <div className="apply-action">
                            <a href="mailto:hr@jdshospitals.com" className="email-btn"><FaEnvelope /> hr@jdshospitals.com</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Careers;
